export type BillingTier = "free" | "pro" | "enterprise";

export interface WorkspaceEntitlements {
  tier: BillingTier;
  maxAudits: number | "unlimited";
  maxMembers: number | "unlimited";
  maxStorageMb: number | "unlimited";
  hasTemplates: boolean;
  hasApiAccess: boolean;
  hasPrioritySupport: boolean;
}

export const PLAN_LIMITS: Record<BillingTier, WorkspaceEntitlements> = {
  free: {
    tier: "free",
    maxAudits: 3,
    maxMembers: 1,
    maxStorageMb: 500,
    hasTemplates: false,
    hasApiAccess: false,
    hasPrioritySupport: false,
  },
  pro: {
    tier: "pro",
    maxAudits: "unlimited",
    maxMembers: 10,
    maxStorageMb: 10240,
    hasTemplates: true,
    hasApiAccess: false,
    hasPrioritySupport: true,
  },
  enterprise: {
    tier: "enterprise",
    maxAudits: "unlimited",
    maxMembers: "unlimited",
    maxStorageMb: "unlimited",
    hasTemplates: true,
    hasApiAccess: true,
    hasPrioritySupport: true,
  },
};
